import { render } from "./MotorTable.vue?vue&type=template&id=06b23fee&scoped=true"
import script from "./MotorTable.vue?vue&type=script&lang=js"
export * from "./MotorTable.vue?vue&type=script&lang=js"

import "./MotorTable.vue?vue&type=style&index=0&id=06b23fee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b23fee"],['__file',"src/views/ProductManage/ModelManagement/components/MotorPageComponent/MotorTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06b23fee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06b23fee', __exports__)) {
    api.reload('06b23fee', __exports__)
  }
  
  module.hot.accept("./MotorTable.vue?vue&type=template&id=06b23fee&scoped=true", () => {
    api.rerender('06b23fee', render)
  })

}


export default __exports__